module.exports = __webpack_public_path__ + "static/media/presention-chart.99a2d28e.svg";